import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axiosInstance from "../../../services/API";


export const createGroupPostComment = createAsyncThunk(
    "createGroupPostComment",
    async ({ postId, post_comment_box }, { rejectWithValue }) => {
        try {
            const response = await axiosInstance.post(`group/groups/comment/${postId}/`, {
                post_comment_box,
            });
            const result = response.data;
            return result;
        } catch (error) {
            if (error.response) {
                return rejectWithValue({
                    status: error.response.status,
                    message: error.response.data?.message || "post save failed",
                });
            }
            return rejectWithValue({
                status: 500,
                message: error.message || "Network error",
            });
        }
    }
);

export const getGroupPostComments = createAsyncThunk(
    "getGroupPostComments",
    async ({ postId, page }, { rejectWithValue }) => {
        try {
            const response = await axiosInstance.get(
                `/group/groups/${postId}/comments/?page=${page}`
            );
            const result = response.data;
            return result;
        } catch (error) {
            if (error.response) {
                return rejectWithValue({
                    status: error.response.status,
                    message: error.response.data?.message || "get saved posts failed",
                });
            }
            return rejectWithValue({
                status: 500,
                message: error.message || "Network error",
            });
        }
    }
);
export const deleteGroupPostComment = createAsyncThunk(
    "deleteGroupPostComment",
    async ({ commentId }, { rejectWithValue }) => {
        try {
            const response = await axiosInstance.delete(
                `/group/groups/delete_comment/${commentId}/`
            );
            const result = response.data;
            return { result, id: commentId };
        } catch (error) {
            if (error.response) {
                return rejectWithValue({
                    status: error.response.status,
                    message: error.response.data?.message || "post delete failed",
                });
            }
            return rejectWithValue({
                status: 500,
                message: error.message || "Network error",
            });
        }
    }
);
export const updateGroupComment = createAsyncThunk(
    "updateGroupComment",
    async ({ commentId, post_comment_box }, { rejectWithValue }) => {
        try {
            const response = await axiosInstance.patch(
                `/group/groups/update_comment/${commentId}/`,
                { post_comment_box }
            );
            const result = response.data;
            return { result, id: commentId };
        } catch (error) {
            if (error.response) {
                return rejectWithValue({
                    status: error.response.status,
                    message: error.response.data?.message || "post update failed",
                });
            }
            return rejectWithValue({
                status: 500,
                message: error.message || "Network error",
            });
        }
    }
);

export const groupPostCommentLike = createAsyncThunk(
    "groupPostCommentLike",
    async ({ commentId }, { rejectWithValue }) => {
        try {
            const response = await axiosInstance.post(
                `/group/groups/like_comment/${commentId}/`
            );
            const result = response.data;
            return { result, id: commentId };
        } catch (error) {
            if (error.response) {
                return rejectWithValue({
                    status: error.response.status,
                    message: error.response.data?.message || "post like failed",
                });
            }
            return rejectWithValue({
                status: 500,
                message: error.message || "Network error",
            });
        }
    }
);
/// reply comment
export const createGroupPostCommentReply = createAsyncThunk(
    "createGroupPostCommentReply",
    async ({ commentId, data }, { rejectWithValue }) => {
        try {
            const response = await axiosInstance.post(
                `/group/groups/comment/${commentId}/replies/`,
                data
            );
            const result = response.data;
            return result;
        } catch (error) {
            if (error.response) {
                return rejectWithValue({
                    status: error.response.status,
                    message: error.response.data?.message || "post save failed",
                });
            }
            return rejectWithValue({
                status: 500,
                message: error.message || "Network error",
            });
        }
    }
);
export const getGroupPostCommentReplies = createAsyncThunk(
    "getGroupPostCommentReplies",
    async ({ commentId }, { rejectWithValue }) => {
        try {
            // Ensure the commentId is valid
            if (!commentId) {
                throw new Error("Comment ID is required to fetch replies.");
            }

            // Make the GET request
            const response = await axiosInstance.get(
                `/group/groups/comments/${commentId}/replies/`
            );
            const result = response.data;

            return result;
        } catch (error) {

            if (error.response) {
                return rejectWithValue({
                    status: error.response.status,
                    message: error.response.data?.message || "Failed to fetch replies",
                });
            }

            return rejectWithValue({
                status: 500,
                message: error.message || "Network error",
            });
        }
    }
);

export const deleteGroupPostCommentReply = createAsyncThunk(
    "deleteGroupPostCommentReply",
    async ({ replyId }, { rejectWithValue }) => {
        try {
            const response = await axiosInstance.delete(
                `/group/groups/comment/${replyId}/delete_reply/`
            );
            const result = response.data;
            return { result, id: replyId };
        } catch (error) {
            if (error.response) {
                return rejectWithValue({
                    status: error.response.status,
                    message: error.response.data?.message || "post delete failed",
                });
            }
            return rejectWithValue({
                status: 500,
                message: error.message || "Network error",
            });
        }
    }
);

export const updateGroupPostCommentReply = createAsyncThunk(
    "updateGroupPostCommentReply",
    async ({ replyId, data }, { rejectWithValue }) => {
        try {
            const response = await axiosInstance.patch(
                `/group/groups/comment/${replyId}/reply/`,
                data
            );
            const result = response.data;
            return result;
        } catch (error) {
            if (error.response) {
                return rejectWithValue({
                    status: error.response.status,
                    message: error.response.data?.message || "post update failed",
                });
            }
            return rejectWithValue({
                status: 500,
                message: error.message || "Network error",
            });
        }
    }
);

export const groupPostCommentLikeReply = createAsyncThunk(
    "groupPostCommentLikeReply",
    async ({ replyId }, { rejectWithValue }) => {
        try {
            const response = await axiosInstance.post(
                `/group/groups/comment/like_reply/${replyId}/`
            );
            const result = response.data;
            return { result, replyId };
        } catch (error) {
            if (error.response) {
                return rejectWithValue({
                    status: error.response.status,
                    message: error.response.data?.message || "post like failed",
                });
            }
            return rejectWithValue({
                status: 500,
                message: error.message || "Network error",
            });
        }
    }
);
export const postCommentReport = createAsyncThunk(
    "postCommentReport",
    async ({ commentId, data }) => {
        try {
            const response = await axiosInstance.post(
                `/group/groups/group-post-comment-reports/${commentId}/`, data);
            const result = response.data;
            return result;
        } catch (error) {
            return error;
        }
    }
);

export const GroupPostCommentsSlice = createSlice({
    name: "GroupPostCommentsSlice",
    initialState: {
        data: [],
        commentReplies: [],
        currentPage: 1,
        hasMore: false,
        loading: false,
        replyLoading: false,
        error: null,
    },
    extraReducers: (builder) => {
        // Create group post comment action promises
        builder.addCase(createGroupPostComment.pending, (state) => {
            state.loading = true;
        });
        builder.addCase(createGroupPostComment.fulfilled, (state) => {
            // state.data = [action.payload, ...state.data];
            state.loading = false;
        });
        builder.addCase(createGroupPostComment.rejected, (state, action) => {
            state.loading = false;
            state.error = action.payload;
        });

        // Create group post comment action promises
        builder.addCase(getGroupPostComments.pending, (state) => {
            state.loading = true;
            state.data = [];
        });
        builder.addCase(getGroupPostComments.fulfilled, (state, action) => {
            state.data = action.payload.results.comments;
            state.next = action.payload.next;
            state.previous = action.payload.previous;
            state.loading = false;
        });
        builder.addCase(getGroupPostComments.rejected, (state, action) => {
            state.loading = false;
            state.error = action.payload;
        });

        // Delete group post comment action promises
        builder.addCase(deleteGroupPostComment.pending, (state) => {
            state.loading = true;
        });
        builder.addCase(deleteGroupPostComment.fulfilled, (state, action) => {
            state.loading = false;
            state.data = state.data.filter(
                (comment) => comment.id !== action.payload.id
            );
        });
        builder.addCase(deleteGroupPostComment.rejected, (state, action) => {
            state.loading = false;
            state.error = action.payload;
        });

        /// get reply comments
        builder.addCase(getGroupPostCommentReplies.pending, (state) => {
            state.replyLoading = true;
        });
        builder.addCase(getGroupPostCommentReplies.fulfilled, (state, action) => {
            state.commentReplies = action.payload.replies;
            state.replyLoading = false;
        });
        builder.addCase(getGroupPostCommentReplies.rejected, (state, action) => {
            state.replyLoading = false;
            state.error = action.payload;
        });

        // create reply comment
        builder.addCase(createGroupPostCommentReply.pending, (state) => {
            state.replyLoading = true;
        });
        builder.addCase(createGroupPostCommentReply.fulfilled, (state, action) => {
            state.replyLoading = false;
            state.commentReplies = [action.payload, ...state.commentReplies];
        });
        builder.addCase(createGroupPostCommentReply.rejected, (state, action) => {
            state.replyLoading = false;
            state.error = action.payload;
        });

        //delete reply comment
        builder.addCase(deleteGroupPostCommentReply.pending, (state) => {
            state.replyLoading = true;
        });
        builder.addCase(deleteGroupPostCommentReply.fulfilled, (state, action) => {
            state.replyLoading = false;
            state.commentReplies = state.commentReplies.filter(
                (reply) => reply.id !== action.payload.id
            );
        });
        builder.addCase(deleteGroupPostCommentReply.rejected, (state, action) => {
            state.replyLoading = false;
            state.error = action.payload;
        });

        // update reply comment

        builder.addCase(updateGroupPostCommentReply.pending, (state) => {
            state.replyLoading = true;
        });
        builder.addCase(updateGroupPostCommentReply.fulfilled, (state, action) => {
            state.replyLoading = false;
            const index = state.commentReplies.findIndex(
                (reply) => reply.id === action.payload.id
            );
            if (index !== -1) {
                state.commentReplies[index] = action.payload;
            }
        });
        builder.addCase(updateGroupPostCommentReply.rejected, (state, action) => {
            state.replyLoading = false;
            state.error = action.payload;
        });

        builder.addCase(groupPostCommentLikeReply.pending, (state) => {
            // state.replyLoading = true;
        });
        builder.addCase(groupPostCommentLikeReply.fulfilled, (state, action) => {
            state.replyLoading = false;
            state.commentReplies = state.commentReplies.map((reply) => {
                if (reply.id === action.payload.replyId) {
                    return {
                        ...reply,
                        is_liked: !reply.is_liked,
                        like_count: action.payload.result.is_liked
                            ? reply.like_count + 1
                            : reply.like_count - 1,
                    };
                }
                return reply;
            });
        });
        builder.addCase(groupPostCommentLikeReply.rejected, (state, action) => {
            state.replyLoading = false;
            state.error = action.payload;
        });
    },
});

export default GroupPostCommentsSlice.reducer;